import TimeAxisBase from './TimeAxisBase.js';

/**
 * @module Scheduler/view/HorizontalTimeAxis
 */

/**
 * A visual horizontal representation of the time axis described in the
 * {@link Scheduler.preset.ViewPreset#field-headers} field.
 * Normally you should not interact with this class directly.
 *
 * @extends Scheduler/view/TimeAxisBase
 * @private
 */
export default class HorizontalTimeAxis extends TimeAxisBase {

    static $name = 'HorizontalTimeAxis';

    static type = 'horizontaltimeaxis';

    static configurable = {
        model            : null,
        sizeProperty     : 'width',
        positionProperty : 'insetInlineStart'
    };

    get width() {
        return this.size;
    }
}
